import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var CheckLarge = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M40 0a40 40 0 1040 40A40 40 0 0040 0zm19.52 28.15L36 54.4a1.78 1.78 0 01-2.67 0L20.48 40.1a1.92 1.92 0 01.1-2.65 1.78 1.78 0 012.57.1l11.49 12.81L56.85 25.6a1.78 1.78 0 012.57-.1 1.92 1.92 0 01.1 2.65z" })), '0 0 80 80', 'CheckLarge');
//# sourceMappingURL=CheckLarge.js.map